import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=894cbcc4&scoped=true&"
import script from "./Order.ts?vue&type=script&lang=ts&"
export * from "./Order.ts?vue&type=script&lang=ts&"
import style0 from "./Order.scss?vue&type=style&index=0&id=894cbcc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894cbcc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDialog,VRow})
